import { render } from "./CreateProjectForm.vue?vue&type=template&id=4e2136cc&scoped=true"
import script from "./CreateProjectForm.vue?vue&type=script&lang=js"
export * from "./CreateProjectForm.vue?vue&type=script&lang=js"

import "./CreateProjectForm.vue?vue&type=style&index=0&id=4e2136cc&scoped=true&lang=css"

import exportComponent from "/home/ec2-user/ContentMoverNodejs/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e2136cc"]])

export default __exports__